



















































import { defineComponent, ref, toRefs } from '@vue/composition-api';
const name = 'ttam-material-native-anchor-model';

export default defineComponent({
  name,
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { visible } = toRefs(props);
    const isShowModel = ref(visible.value);

    function closeDialog() {
      emit('cancel');
      isShowModel.value = false;
    }

    function confirmDialog() {
      emit('confirm');
      isShowModel.value = false;
    }

    return {
      name,
      isShowModel,

      closeDialog,
      confirmDialog,
    };
  },
});
